/** Bump suffix if opener copy/design changes materially and should re-show once. */
export const EVENT_UPDATES_MODAL_STORAGE_KEY = "waveOfInnovation_event_updates_seen_v1";
